import { render, staticRenderFns } from "./SwitchCompanyDialog.vue?vue&type=template&id=5e53c058&scoped=true"
import script from "./SwitchCompanyDialog.vue?vue&type=script&lang=js"
export * from "./SwitchCompanyDialog.vue?vue&type=script&lang=js"
import style0 from "./SwitchCompanyDialog.vue?vue&type=style&index=0&id=5e53c058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e53c058",
  null
  
)

export default component.exports